import { Button } from '@/components/ui/button';
import { Drawer, DrawerContent, DrawerDescription, DrawerFooter, DrawerTitle } from '@/components/ui/drawer';
import { useClientTranslation } from '@/lib/core';

export interface SoldOutEventSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Navigates to the event's read-only detail — sold-out is a capacity issue, not an access one, so the member has legitimate access. */
  onViewAnyway: () => void;
}

/**
 * Sheet shown when a sold-out event card is tapped on the ELP — for members and
 * non-members alike, since it communicates capacity, not access.
 * "Explore other events" simply dismisses (the sheet already opens from the
 * ELP); "View event anyway" navigates to the read-only detail screen.
 */
export function SoldOutEventSheet({ open, onOpenChange, onViewAnyway }: SoldOutEventSheetProps) {
  const t = useClientTranslation();

  return (
    <Drawer open={open} onOpenChange={onOpenChange} showSwipeHandle={false}>
      <DrawerContent className="bg-[#1a1a1a]">
        <div className="flex flex-1 flex-col gap-4 px-4 pt-10 pb-4">
          <DrawerTitle className="font-pp-neue-montreal text-[24px] leading-tight font-semibold text-white">
            {t('App.Events.SoldOutTitle')}
          </DrawerTitle>
          <DrawerDescription className="font-pp-neue-montreal text-[16px] leading-normal tracking-[0.25px] text-[#eaeaea]">
            {t('App.Events.SoldOutDescription')}
          </DrawerDescription>
        </div>

        <DrawerFooter className="flex shrink-0 flex-col gap-2 border-t border-[#c8c8c8]/30 px-4 pt-6 pb-10">
          <Button
            variant="primary-solid"
            palette="white"
            size="lg"
            className="w-full"
            onClick={() => onOpenChange(false)}
          >
            {t('App.Events.ExploreOtherEvents')}
          </Button>
          <Button
            variant="tertiary-link"
            palette="white"
            size="sm"
            className="w-full"
            onClick={() => {
              onOpenChange(false);
              onViewAnyway();
            }}
          >
            {t('App.Events.ViewEventAnyway')}
          </Button>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
}
